import { useSessionStorageValue } from "@react-hookz/web";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { Loader } from "~/components/ui/loader";
import { useBrandInfoQuery } from "~/graphql/graphql-new.gen";

export const LogoutSuccessful: React.FC = () => {
  const location = useLocation();
  const { value: brandId } = useSessionStorageValue<string>("brandId");

  const queryParams = new URLSearchParams(location.search);

  const { data: brandInfoData, isLoading } = useBrandInfoQuery(
    {
      brandId: brandId ?? "",
    },
    {
      enabled: !!brandId && brandId !== "undefined",
      refetchOnWindowFocus: false,
    },
  );

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader className="size-8" />
      </div>
    );
  }

  if (brandInfoData?.brandInfo && !brandInfoData.brandInfo.acceptContract) {
    return <Navigate to={`/${brandId}/onboarding${location.search}`} replace />;
  }

  return queryParams.has("invite-code") ||
    (brandInfoData?.brandInfo?.nbUsers ?? 0) === 0 ? (
    <Navigate to={`/${brandId}/signup${location.search}`} />
  ) : (
    <Navigate to={`/${brandId}/login${location.search}`} />
  );
};

LogoutSuccessful.displayName = "LogoutSuccessful";
